export const computeTickStep = (maxValue: number, minTicks: number = 4) => {
  if (maxValue <= 1) return 1;
  const rawStep = maxValue / (minTicks - 1);
  const powerOfTen = Math.pow(10, Math.floor(Math.log10(rawStep)));

  if (rawStep / powerOfTen >= 5) return powerOfTen * 5;
  if (rawStep / powerOfTen >= 2) return powerOfTen * 2;
  return powerOfTen;
};

export const tickFormatter = (t: number) => {
  return t % 1 === 0 ? `${t}` : `${t.toFixed(1)}`;
};

export const computeTickValues = (maxValue: number) => {
  const copiedMax = Math.ceil(maxValue);
  const tickStep = computeTickStep(copiedMax);

  const tickValues = Array.from(
    { length: Math.floor(copiedMax / tickStep) + 1 },
    (_, i) => i * tickStep,
  );

  if (!tickValues.includes(0)) {
    tickValues.unshift(0);
  }

  return tickValues;
};
